<!-- ToolTipGridContainer.vue -->
<script setup lang="ts">

</script>

<style scoped>
    @import url('../../../css/toolTipGrid.css');
</style>

<template>
    <div class="grid-container">
        <slot />
    </div>
</template>